import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { FederationComponent } from './federation.component';
import { FederationRoutingModule } from './federation-routing.module';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Atuar na conversão do header para que as Apis do TI, consigam
// receber as aquisições corretamente com Json via "RESPONSE HEADERS" e "REQUEST HEADERS"
import { Interceptor } from 'src/app/core/interceptors/http-request-interceptor';
import { ThemeModule } from 'src/app/@theme/theme.module';

@NgModule({
    declarations: [FederationComponent],
    imports: [CommonModule, FederationRoutingModule, Interceptor, ThemeModule],
})
export class FederationModule {}
